import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { IconButton } from '@8x8/oxygen-icon-button'
import ThumbUpIcon from '@8x8/oxygen-icon/novo/ThumbUpIcon'
import ThumbDownIcon from '@8x8/oxygen-icon/novo/ThumbDownIcon'

import { Flex } from '~/components/common/containers'
import { labelBold01Css } from '~/components/common/typography'
import { translate } from '~/core/translate'
import { submitSummaryFeedback } from '~/actions/recents'
import { getSummaryFeedbackSubmitted } from '~/selectors/session-details'

const Container = styled(Flex)`
  ${labelBold01Css};
  align-items: center;

  button {
    margin-left: 8px;
  }
`

const SummaryFeedback = ({ sessionId }) => {
  const dispatch = useDispatch()
  const isFeedbackSubmitted = useSelector(getSummaryFeedbackSubmitted(sessionId))

  const handleLike = () => {
    dispatch(submitSummaryFeedback(sessionId, true))
  }

  const handleDislike = () => {
    dispatch(submitSummaryFeedback(sessionId, false))
  }

  if (isFeedbackSubmitted) {
    return null
  }

  return (
    <Container>
      {translate('meeting_summary_feedback')}

      <IconButton onClick={handleLike}>
        <ThumbUpIcon />
      </IconButton>
      <IconButton onClick={handleDislike}>
        <ThumbDownIcon />
      </IconButton>
    </Container>
  )
}

export default SummaryFeedback
